<template>
  <div class="dc-js-chart pie-chart">
    <div class="header">
      <slot>
        <h2>
          {{ title }}
        </h2>
      </slot>
      <a class="reset" @click="reset()" style="display: none">
        <i class="material-icons refresh button">refresh</i>
      </a>
    </div>

    <a
      href="javascript:;"
      class="download-data"
      :download="downloadName"
      title="Download data"
      @mouseenter="setDownloadData()"
    >
      <i class="material-icons get-app">get_app</i>
    </a>

    <div class="pie-detail" v-if="totals.show">
      <div class="percentage">{{ totals.percentage }}%</div>
      <div class="value">{{ totals.value }}</div>
      <!--<div class="capex">$ {{ totals.capex }}M</div>-->
    </div>
  </div>
</template>

<script>
import mixin from './mixin';
import { setTimeout } from 'timers';

export default {
  mixins: [mixin],
  props: {
    downloadName: {
      type: String,
      default: 'download.csv'
    },
    downloadColumns: {
      type: Array,
      default() { return ['Key', 'Value'] }
    },
    pieAttrs: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {totals: {show: false, percentage: '', amount: '', value: '' }};
  },
  methods: {
    createChart(ndx) {
      this.chart = dc.pieChart(this.$el);
      const attrs = this.pieAttrs;
      const dimension = ndx.dimension(d => d[this.dimensionField]);
      const group = dimension.group().reduceSum(d => d[this.aggField]);
      const values = dimension.group().all();
      const colorScaleComponent = d3
        .scaleOrdinal()
        .domain(values.map(v => v.key))
        .range(this.colors.slice(0, values.size));

      this.chart
        .width(attrs.width)
        .height(attrs.height)
        .radius(attrs.radius)
        .innerRadius(attrs.innerRadius)
        .dimension(dimension)
        .group(group)
        .colors(colorScaleComponent)
        .slicesCap(15)
        .cx(attrs.radius)
        .ordering(d => {
          return d.value;
        })
        .title(this.titleFn)
        .on('pretransition', chart => {
          chart.selectAll('text.pie-slice').text(this.titleFn);
        })
        .legend(
          dc
            .legend()
            .x(attrs.radius * 2 + 5)
            .y(5)
            .autoItemWidth(true)
            .gap(5),
        )
        .on('postRender', (chart) => {
          this.$_showTotals(group);
        });

      ndx.onChange((event) => {
        if ('filtered' === event) {
          setTimeout(() => {
            this.$_showTotals(group);
          }, 100);
        }
      });

      dc.override(this.chart, 'legendables', () => {
        const items = this.chart._legendables();
        return items.reverse();
      });
    },
    $_showTotals(group) {
      const total = group.all().reduce((s, a) => { return s += a.value },0);
      const frm = d3.format(',.2f');

      d3.select(this.$el).selectAll('.dc-legend-item')
        .on('mouseenter', (el) => {
          this.totals.show = true;
          this.totals.percentage = frm(100.0 *  el.data / total);
          this.totals.value = frm(el.data);
        })
        .on('mouseout', (el) => {
          this.totals.show = false;
        });
    },
    //
    setDownloadData() {
      let arr = [this.downloadColumns.join(',')];
      const data = this.chart.data().sort((a, b) => a.value < b.value ? 1 : -1);
      data.forEach(d => { arr.push([d.key, d.value].join(',')) });

      this.$el.querySelector('a.download-data').href = 'data:text/csv;charset=utf-8,' + arr.join('\n');
    }
  },
};
</script>

<style>
.dc-chart .pie-label {
  display: none;
}
.dc-chart .pie-detail {
  position: absolute;
  z-index: 100;
  bottom: 85px;
  left: 35px;
  width: 90px;
  text-align: center;
}
.pie-chart .percentage {
  font-size: 16px;
  color: #7f7f7f;
  font-weight: bold;
}
.pie-chart .value {
  color: black;
  font-size: 14px;
}
.pie-chart .capex {
  color: #999;
  font-size: 13px;
}
.pie-chart .download-data {
  position: absolute;
  right: 50px;
  top: 23px;
  color: #333;
}
</style>
